<template>
    <v-card flat class="card-style">
        <v-card-text :class="`${determinarCorBg} text-card-mensagem`">
            <div>
                <h4 v-if="ehMensagemDeTerceiros" class="usuario primary--text text-uppercase mb-1">
                    {{ mensagem.remetente.nome }}
                </h4>
                <p class="mensagem">
                    {{ mensagem.text }}
                </p>
            </div>
        </v-card-text>
        <div class="data-horario-mensagem">
            <span class="blue-grey--text lighten-3">
                {{ mensagem.dataHora | az-date(humanizarFormatoDataHora(mensagem.dataHora)) }}
            </span>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'ChatMensagem',
    props: {
        mensagem: {
            type: Object,
            required: true
        },
    },
    data: () => ({}),
    computed: {
        ehMensagemDeTerceiros() {
            return !this.mensagem.ehMensagemMinha
        },

        determinarCorBg() {
            return this.ehMensagemDeTerceiros ? 'blue-grey lighten-5' : 'light-blue lighten-5'
        }
    }
}
</script>

<style scoped lang="stylus">
        .card-style
            background-color white
            border-radius 10px
            margin 20px 0;

        .text-card-mensagem
            border-radius 10px
            padding 10

        .usuario
            font-size 0.95rem

        .mensagem
            font-size 0.95rem
            margin 0

        .data-horario-mensagem
            display flex
            justify-content flex-end
            font-size .75rem
</style>